import React from 'react';

import { ExpectedDeliveryDate } from './ExpectedDeliveryDate';
import { ExpectedDeliveryDateNoPostalCodeInfo } from './ExpectedDeliveryDateNoPostalCodeInfo';
import { PresentedDeliveryMethod } from './PresentedDeliveryMethod';

export interface ExpectedDeliveryDateProps {
    postalCode: string | null;
    openModal: () => void;
    presentedDeliveryMethod: PresentedDeliveryMethod;
    isPresentedDeliveryMethodAvailable: boolean | null;
    isAnyDeliveryMethodAvailable: boolean;
    isCooledProduct: boolean;
    cooledDeliveryInfoPage: string;
}

export const ExpectedDeliveryDateView = (props: ExpectedDeliveryDateProps) => {
    return (
        <div className="ExpectedDeliveryDateView">
            <div className="ExpectedDeliveryDateView__Wrapper">
                {props.postalCode && props.presentedDeliveryMethod.methodName ? (
                    <ExpectedDeliveryDate
                        postalCode={props.postalCode}
                        openModal={props.openModal}
                        deliveryMethod={props.presentedDeliveryMethod}
                        isCooledProduct={props.isCooledProduct}
                        cooledDeliveryInfoPage={props.cooledDeliveryInfoPage}
                        isAnyDeliveryMethodAvailable={props.isAnyDeliveryMethodAvailable}
                    />
                ) : (
                    <ExpectedDeliveryDateNoPostalCodeInfo
                        isCooledProduct={props.isCooledProduct}
                        cooledDeliveryInfoPage={props.cooledDeliveryInfoPage}
                        openModal={props.openModal}
                    />
                )}
            </div>
        </div>
    );
};
